// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"23bc3cdb","212":"4af02abf","248":"6810d10c","396":"84f13bca","421":"25b1d5ea","655":"d3e4275c"}[chunkId] + ".chunk.css";
};